import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Blogres is done with",
  "description": "",
  "published": "2008-06-23T00:00:00.000Z",
  "redirect_from": ["/blog/blogres-is-done-with/swizec/101"],
  "categories": "intrigues",
  "hero": "./img/3144-2597952904_32782da125.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=news/id=329"
      }}>{`Blogres came`}</a>{` and went and now it's over. I've arleady written a blog about it on poper's site, and don't really like writing another right now. But I will say this: my photo is on the bloody frontpage of blogres! I swear there was this photographer who kept taking close-up photos of me and even though I don't really know what happened to the lot of them, one made it to the front page.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "500px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/fb1278ff37e2a427cefcc70d00be7f77/41099/3144-2597952904_32782da125.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "68.60986547085201%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'274\\'%20viewBox=\\'0%200%20400%20274\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2036v45h4l9%201h10l3%201%204%201-4%201h5a443%20443%200%200047%204v-2l4%201c2%200%202%200%201%201-2%201-1%202%201%202%203-2%202%201-1%202-4%201-4%203%201%203h3l2%206a291%20291%200%20017%2035c2%201%2015%200%2018-2l6-1c2%200%203%200%202-1s0-1%203-2l6-1%206-2%207-1c1-1%200-1-4-1l-5%201-2-4c-1-5-2-12-1-13l1%201c0%201%205%201%2014-1%205-1%208-2%205-2l-1-1-1-1c-2-1-2-6%201-8l2-2-2-1c-2%200-2-1-1-1%201-2%204%200%203%201l5%201c4-1%205%200%206%201v8l-1%202h8l-2-4c-2%200-3-5-2-6%200-2%203-1%203%201l2%201%201%204c0%203%201%204%202%202l1%208v9h-3l-5%201c0%201%2011%201%2012-1l-1-13-2-18c0-6%202%200%205%2020v5l1-4%201-4%201%203%206%2010c1%201%200%201-2%201l-2%201h2l3%201c-1%201%200%201%202%201h3v-9a133%20133%200%2000-1-12c1%201%202%209%202%2021%201%205%202%204%202-2l1-8c0-3%200-3-1-2s-1%201-1-2c0-2%200-3%201-2l1-1%201-1c6%200%206-11%201-22-1-3-1-5%202-14%201-5%202-7%206-7%202-1%203-1%203-3s2-3%202%200v-5c0-8%206-22%2011-24l3-3%203-2%202-1%202-2%203-4c2-3%202-4%205-4l-4-1c-6-1-6-1%204-1h11l-16-1a971%20971%200%2000-84%200%207689%207689%200%2000-151%200l-5-1v24m77-20l-3%203c-3%203%207%208%2013%205s-3-10-10-8m-40%208c-5%203%200%207%207%207%208%200%209-3%204-6-4-2-8-3-11-1m252%2017c-8%202-16%208-18%2015%200%203-3%207-8%209l-3%204c1%202%208%206%2010%205l1%201%202%202v-1l1-1h1c0-3%2010-4%2014-2%201%202%204%202%204%200l2-2c5-3%208%201%204%206v2c2%200%204%204%204%207%200%202-12%2014-14%2014l-3-4-2-4-4%202-6%201-2%201%203%201c4%200%204%200%201%204l-4%203c-6%200-9%201-9%203l-1%203-2%202c0%202-6%2011-8%2011l-1-5c0-5%200-5-1-2v10c0%208-1%2010-6%2010-4%200-5-1-5-7v-4l-2%203c-1%202-1%208%201%2012%200%201-1%202-6%202-6%201-8%201-15%204-6%202-7%202-10%200a100%20100%200%2000-15-6c-2-1-10%200-12%201l-15%207c-8%201-10%209-2%2012l5%202v8c-2%207-4%2022-4%2038-1%2016-1%2017-10%2019-2%201-4%207-2%2010%202%202%206%204%2011%204l6%202%203%201%201%201%204%201%203%201%203%201h4c2%201%202%201%202-1%200-1%200-2%202-2l5-4%206-2c4%200%206-2%207-8%200-6%201-8%202-6h1l1-2%201%202%203%206%202%207%201%203%202%208%201%207%202%202v2l5%201h6l-1-3a237%20237%200%2000-10-26%20450%20450%200%2000-15-39c-4-4-5%205-1%2011%204%209%202%2018-5%2018-12%200-13%201-15%203-3%203-4%203-4-1l2-12c2-27%203-30%206-31h13c-1%201%202%207%203%207l1-2v-3l1%202c0%202%201%203%204%204%202%200%203%201%203%202h1l2-1c2%200%202%200%201%201l6%201c8%200%209-1%209-2%200-2%200-2-1-1l-1%201c-2%200%203-10%207-14%205-6%207-6%204-1l-3%209-2%203c0-2-2-3-2%200l-1%204%201%202c1-1%202%200%203%204%202%204%203%204%2014%2010a163%20163%200%200035%2012c8%201%2010%202%2027%2010a141%20141%200%200050%2016l3%201c1%201%201%200%201-1%200-2%200-2%201%201l1-44v-46l-6%201-9%202-12-4-2-1c-4%200-6-9-6-21l-1-7-1-6c0-11-2-14-17-25-2-2-2-2-1-4v-2l-1-2-1-3a632%20632%200%200020-8c-15%203-20%204-17%202l29-7a135%20135%200%200124-5l-1-1%202-2h-1l-31%208a4075%204075%200%2000-29%204%20653%20653%200%200161-17c0-2%200-2-2-1l-2%202-16%204c-40%2011-45%2012-36%207l4-4c1-1%205-3%2013-5l11-5-12%203c-9%204-11%204-11%203l-4-2c-5%200-6-1-6-5-2-11-12-16-24-14M13%20118a330%20330%200%20002%2063h2l5-2%202-1%204-2%204-2h-1l-3-1%202-1h3l2-1c4%200%205-2%202-2-2-1-2-1%201-1%202%200%203%200%202%201l1%201%203-1-1-1c-2-1-2-1%202-1l8-1%208-2%204-1-3-1h-4c-1-1%200-1%201-1%203%200%208-3%208-4l1-1h2v2l3-2%203-2c1%201%203%200%205-2l5-3c1%200%201%201-1%202s-2%201%201%201l5-1%204-2c3%200%208-3%206-4h1l1-2c-2-1%200-3%202-3%203%200%204-2%202-4l-2-2h-4c-5%200-7-1-3-2%202-1%202-1%201-2v-4c2-1%202-2%200-4s-3-5-3-8c-1-3-4-6-4-3%200%201-4%201-6-1-2%200-2-1-1-1l1-3c0-3%200-3%203-2s4%200%203-2l-2-2h-3c-2-2-4-2-6-1l-2%201-18-1-6-1c-1-1-9-2-21-2l-3-1-15-3h-3v26m62%208c-7%200-8%201-4%205%203%203%203%203%208%202%206-1%206-2%205-5%200-2-1-3-2-3l-7%201m199%2035c-4%201-8%203-5%203l6%203%204%202%2011-1c15%200%2016%200%2016-2%200-3-24-7-32-5m-4%2032l-6%201c-2%200-3%200-3%202%200%203%203%204%2011%207a366%20366%200%200124%2010l-14-12-7-6c0-2-3-3-5-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fb1278ff37e2a427cefcc70d00be7f77/ca0a1/3144-2597952904_32782da125.webp 223w", "/static/fb1278ff37e2a427cefcc70d00be7f77/75680/3144-2597952904_32782da125.webp 445w", "/static/fb1278ff37e2a427cefcc70d00be7f77/b0a15/3144-2597952904_32782da125.webp 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fb1278ff37e2a427cefcc70d00be7f77/853b2/3144-2597952904_32782da125.jpg 223w", "/static/fb1278ff37e2a427cefcc70d00be7f77/0a4fe/3144-2597952904_32782da125.jpg 445w", "/static/fb1278ff37e2a427cefcc70d00be7f77/41099/3144-2597952904_32782da125.jpg 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/fb1278ff37e2a427cefcc70d00be7f77/41099/3144-2597952904_32782da125.jpg",
                "alt": "Swizec at blogres",
                "title": "Swizec at blogres",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Swizec at blogres`}</figcaption>{`
  `}</figure></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      